// removed by extract-text-webpack-plugin
module.exports = {"list":"_35exJ","listTitle":"_3BZmv","listItem":"_3jKDL","link":"_1zFdi"};